module.exports = __webpack_public_path__ + "img/full_logo_v_fr.fa8d4035.svg";